"use client";

import { useRouter } from "next/navigation";
import { useAppSelector } from "@/redux/store";
import React, { useEffect, useRef, useState, FC, SVGProps } from "react";
import { usePathname } from "next/navigation";
import { calculateProfilePercentage } from "@/helpers/utils/utility-functions";
import { useDispatch } from "react-redux";
import { signOut } from "@/helpers/firebase/auth";
import { logOut } from "@/redux/features/app-slice";
import { resetState as resetMarketPlaceState } from '@/redux/features/market-place-slice';
import Image from "next/image";
import * as _ from "lodash";
import ProgressBar from "@ramonak/react-progress-bar";
import styles from "./Navbar.module.css";
import AppleWalletIcon from "../../../../public/images/apple-wallet-icon.svg";
import ProfileIcon from "../../../../public/images/profileNavbar/profile.svg";
import ManageAccountIcon from "../../../../public/images/profileNavbar/manage_account.svg";
import CreatorAccountIcon from "../../../../public/images/profileNavbar/creator_account.svg";
import AntiHarassmentIcon from "../../../../public/images/profileNavbar/anti_harras_policy.svg";
import CodeConductIcon from "../../../../public/images/profileNavbar/code_conduct.svg";
import TermsConditionIcon from "../../../../public/images/profileNavbar/terms_condition.svg";
import PrivacyPolicyIcon from "../../../../public/images/profileNavbar/privacy_policy.svg";
import FaqIcon from "../../../../public/images/profileNavbar/faq.svg";
import WhatIcon from "../../../../public/images/profileNavbar/what_new.svg";
import EarlyAccessIcon from "../../../../public/images/profileNavbar/early_access.svg";
import InviteFriendsIcon from "../../../../public/images/profileNavbar/invite_friends.svg";
import SendFeedbackIcon from "../../../../public/images/profileNavbar/feedback.svg";

import { MenuItem } from "@/models/menuItem";

const initialMenu: MenuItem[] = [
  {
    name: "Profile",
    href: "/profile",
    IconComponent: ProfileIcon
  },
  {
    name: "Admin Panel",
    href: "/admin/announcement",
    IconComponent: ManageAccountIcon
  },
  {
    name: "Manage Account",
    href: "#",
    IconComponent: ManageAccountIcon
  },
  {
    name: "Creator Account",
    href: "/profile/creator",
    IconComponent: CreatorAccountIcon
  },
];

const AboutMenu: MenuItem[] = [
  {
    name: "Anti-Harrassment Policy",
    href: "/profile/anti-harassament-policy",
    IconComponent: AntiHarassmentIcon,
  },
  {
    name: "Code of Conduct",
    href: "/profile/code-of-conduct",
    IconComponent: CodeConductIcon,
  },
  {
    name: "Terms of Service",
    href: "/profile/terms-of-service",
    IconComponent: TermsConditionIcon,
  },
  {
    name: "Privacy Policy",
    href: "/profile/privacy-policy",
    IconComponent: PrivacyPolicyIcon,
  },
  {
    name: "FAQ",
    href: "/profile/faq",
    IconComponent: FaqIcon,
  },
];

const OthersMenu: MenuItem[] = [
  {
    name: "What’s New",
    href: "/",
    IconComponent: WhatIcon,
  },
  {
    name: "Early Access",
    href: "/",
    IconComponent: EarlyAccessIcon,

  },
  {
    name: "Invite Friends",
    href: "/",
    IconComponent: InviteFriendsIcon,

  },
  {
    name: "Send Feedback",
    href: "/",
    IconComponent: SendFeedbackIcon,

  },

];

export default function ProfileBar({ show, setter }: any) {
  const router = useRouter();
  const upcomingChildRef = useRef<any>(null);
  const pathname = usePathname();

  const dispatch = useDispatch();
  const userData = useAppSelector((state) => state.appReducer.userData);
  const [profileCompletion, setProfileCompletion] = useState(33);

  useEffect(() => {
    if (userData) {
      setProfileCompletion(calculateProfilePercentage(userData));
    }
  }, [userData]);

  const handleInitialMenuItemClick = async (index: number) => {
    const selectedMenuItem = initialMenu[index];
    if (selectedMenuItem.href) {
      router.push(selectedMenuItem.href);
    } else if (selectedMenuItem.fn) {
      selectedMenuItem.fn();
    }
    setter(false);
  };

  const doLogOut = () => {
    signOut();
    dispatch(logOut());
    dispatch(resetMarketPlaceState());
    router.push("/");
  };

  return (

    <>
      <div
        className={`h-screen pt-7 pl-[1.875rem] flex-col flex  overflow-y-scroll no-scrollbar bg-white bg-opacity-30`}
      >
        <div className="flex justify-between items-center">
          <Image
            height={34}
            width={80}
            className="mt-0"
            src="/images/C-Tribe_Main_Logo.svg"
            alt="c-tribe"
          />
        </div>

        <div
          className="flex flex-col cursor-pointer "
          onClick={() => {
            router.push("/");
          }}
        >
          <div className={`flex justify-start items-center`}>
            <div className={`flex items-center justify-start mt-6`}>
              <Image
                src={"/images/profileNavbar/home_back.svg"}
                width={20}
                height={20}
                alt="sideBar"
                color="inherit"
                style={{ objectFit: "contain" }}
                quality={75}
              />
              <span className={`ml-3 text-sm font-medium`}>Home</span>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-start mt-4">
          <span className={`text-sm font-medium`}>Account Settings</span>
        </div>

        <div className="gap-7 mt-5">
          {initialMenu.map((item, index) => {
            const IconComponent = item.IconComponent;
            const isSelected = pathname === item.href;
            const iconColor = isSelected ? "#333E48" : "#909090";
            return (item.name === "Profile" ?
              <div
                key={index}
                className={`cursor-pointer flex flex-col justify-start items-start`}
                onClick={() => handleInitialMenuItemClick(index)}
              >
                <div className="flex items-center justify-start">
                  {IconComponent && (
                    <IconComponent width={20} height={20} style={{ color: iconColor }} />
                  )}
                  <div className="ml-3">
                    <span
                      className={`text-sm ${pathname === item.href
                        ? "font-bold text-black"
                        : "font-normal text-custom-gray2"
                        } ${pathname == item.href ? "" : styles.unselectedMenuItem
                        }`}
                    >
                      {item.name}
                    </span>
                    {
                      profileCompletion < 100 &&
                      <ProgressBar
                        completed={profileCompletion}
                        height={"6px"}
                        width={"7.8125rem"}
                        isLabelVisible={false}
                        bgColor={
                          "linear-gradient(to right, #4891DC, #8985D5,#E09DDC)"
                        }
                      />
                    }

                  </div>
                </div>
              </div> :

              <div
                key={index}
                className={`cursor-pointer flex justify-start items-center mt-6  ${(item.name === "Creator Account" &&
                  userData?.role !== "creator") ||
                  (item.name === "Admin Panel" && userData?.role !== "admin")
                  ? "hidden"
                  : "block"
                  }`}
                onClick={() => handleInitialMenuItemClick(index)}
              >
                <div className={`flex items-center justify-start`}>
                  {IconComponent && (
                    <IconComponent width={20} height={20} style={{ color: iconColor }} />
                  )}
                  <span
                    className={`ml-3 text-sm ${pathname === item.href
                      ? "font-bold text-black"
                      : "font-normal text-custom-gray2"
                      } ${pathname == item.href ? "" : styles.unselectedMenuItem
                      }`}
                  >
                    {item.name}
                  </span>
                  {/* <span className={`ml-3 text-sm font-normal ${styles.profileMenuItem}`}>{item.name}</span> */}
                </div>
              </div>
            )
          }
          )}
        </div>

        <div>
          <hr className="mr-4 mt-6 h-[1px] border-t-0 bg-[#C4C4C4]" />
        </div>

        <div className="flex items-center justify-start mt-4">
          <span className={`text-sm font-medium`}>About</span>
        </div>

        <div
          className={`flex flex-col justify-between items-start`}
          ref={upcomingChildRef}
        >
          <div className="flex flex-col gap-7 mt-7">
            {AboutMenu.map((item, index) => {
              const IconComponent = item.IconComponent;
              const isSelected = pathname === item.href;
              const iconColor = isSelected ? "#333E48" : "#909090";

              return (
                <div
                  key={index}
                  className={`flex justify-start items-center`}
                >
                  <div
                    className={`flex items-center justify-start cursor-pointer`}
                    onClick={() => {
                      if (item.href) router.push(item.href);
                    }}
                  >
                    {IconComponent && (
                      <IconComponent width={20} height={20} style={{ color: iconColor }} />
                    )}
                    <span
                      className={`ml-3 text-sm ${styles.profileMenuItem} ${!!item.href && pathname.includes(item.href)
                        ? "text-black font-bold"
                        : "font-normal"
                        }`}
                    >
                      {item.name}
                    </span>
                  </div>
                </div>

              )

            })}
          </div>
        </div>

        {/* <div>
          <hr className="mr-4 mt-6 h-[1px] border-t-0 bg-button-disabled-color" />
        </div>

        <div
          className={`flex flex-col justify-between items-start mt-6`}
          ref={upcomingChildRef}
        >
          <div className="flex flex-col">
            {OthersMenu.map((item, index) => {
              const IconComponent = item.IconComponent;
              const isSelected = pathname === item.href;
              const iconColor = isSelected ? "#333E48" : "#909090";
              return (
                <div key={index} className={`flex justify-start items-center mt-[1.75rem]`}>
                  <div className={`flex items-center justify-start`}>
                    {IconComponent && (
                      <IconComponent width={20} height={20} style={{ color: iconColor }} />
                    )}
                    <span
                      className={`ml-3 text-sm font-normal ${styles.profileMenuItem}`}
                    >
                      {item.name}
                    </span>
                  </div>
                </div>

              )
            })}
          </div>
        </div> */}

        <div
          className="flex flex-col cursor-pointer md:mt-auto mt-6 md:pb-10 pb-20"
          onClick={() => {
            doLogOut();
          }}
        >
          <div className={`flex justify-start items-center`}>
            <div className={`flex items-center justify-start mt-6`}>
              <Image
                src={"/images/profileNavbar/logout.svg"}
                width={20}
                height={20}
                alt="sideBar"
                color="inherit"
                style={{ objectFit: "contain" }}
                quality={75}
              />
              <span className={`ml-3 text-sm font-medium`}>Log out</span>
            </div>
          </div>
        </div>
      </div>
    </>

  );
}
